var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((5),function(index){return [(_vm.rating >= index)?_c('span',{key:index,staticClass:"icon icon--ratingFull"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-star"}})])]):_c('span',{key:index,staticClass:"icon icon--ratingEmpty"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-star"}})])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }